module.exports = __webpack_public_path__ + "img/nota_codigo.c6330f3e.png";